import React from 'react';
import { Routes, Route } from 'react-router-dom';
import StockAverage from '../components/StockAverage';
import HomeLayout from '../HomeLayout'

function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<HomeLayout />}>
                <Route index element={<StockAverage />} />
            </Route>
        </Routes>
    );
}

export default AppRoutes;
